import React from "react";
import PropTypes from "prop-types";
import { RichText } from "@learningblocks/shared-components/lib/RichText";

export function TitleCell(props) {
  const style = {
    ...(props.bgColor && { backgroundColor: props.bgColor }),
  };

  return (
    <th className={props.className} colspan={props.colspan} style={style}>
      <div className={`dataTable_row_title_contents`}>
        <p style={{ textAlign: props.align || "center" }}>
          <RichText value={props.text} />
        </p>
      </div>
    </th>
  );
}

TitleCell.propTypes = {
  /**
   * Text to be displayed on the cell
   */
  text: PropTypes.string,
  /**
   * className to be set on the cell
   */
  className: PropTypes.string,
  /**
   * Optional background color for the cell
   */
  bgColor: PropTypes.string,
  /**
   * Text alignment for the cell (left, center, right). Defaults to center.
   */
  align: PropTypes.oneOf(["left", "center", "right"]),
};
